import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { selectIsAuthenticated } from 'redux/authSlice';
import Logo from '../../assets/images/logo.svg';
import HeadBg from '../../assets/images/head-bg.png';
import { FloatingLabel, Form, Spinner } from 'react-bootstrap';
import 'react-input-code/dist/index.css';
import '../../styles/login.css';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { useResetPasswordMutation } from 'api/authApi';
import { showToastError, showToastSuccess } from 'components/toastify/ToastNotifications';

type Props = {}

const AdminResetPassword = (props: Props) => {

    const params = new URLSearchParams(window.location.search)
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('login');
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const [password, setPassword] = useState<string>('');
    const [pass, setPass] = useState('password');


    useEffect(() => {
        confirmAuthectication();
    }, []);

    const confirmAuthectication = () => {
        if (isAuthenticated) {
            navigate(-1);
        }
    };

    const [resetPassword, data] = useResetPasswordMutation();

    const handleInitiateLogin = async (e: any) => {
        e.preventDefault();
        try {
            setLoading(true); // Set loading state to true
            const model = {
                email: params.get('email') || '',
                token: params.get('token') || '',
                newPassword: password
            }
            const response = await resetPassword(model).unwrap();
            if (response) {
                navigate('/auth/login');
                showToastSuccess(response.ResponseMessage);
            }
        } catch (error: any) {
            showToastError(error.data.ResponseMessage);
        } finally {
            setLoading(false); // Reset loading state to false after the mutation is complete
        }
    };

    return (
        <main className='login-section'>
            <header><img src={Logo} /></header>
            <div className='row mt-5 pt-5'>
                <div className='col-xl-4 col-lg-6 col-md-8 col-sm-12 bg-white p-0 m-auto rounded-4'>
                    <div>
                        <img src={HeadBg} className='rounded-bottom-0 rounded-top-4' width="100%" />
                        <div className='py-5 px-4 mx-2'>
                            <h5 className='fw-bold letter-spacing-1'>Password Reset!</h5>
                            <span className='font-size-sm dark-text lh-sm'>Enter new password to proceed.</span>
                            <Form onSubmit={handleInitiateLogin} className='mb-3'>
                            <div className='my-5'>
                                    <FloatingLabel controlId="floatingInput" label="Password" className="float-input my-4" >
                                    <Form.Control type={pass} onChange={(e) => setPassword(e.target.value)} placeholder='New password' className="font-size-normal" />
                                    </FloatingLabel>
                                    <div className='w-25 position-relative float-end text-end px-4 pointer' style={{ marginTop: "-60px" }}>
                                        {pass === 'text' ? <AiOutlineEye size={25} onClick={() => setPass('password')} /> : <AiOutlineEyeInvisible size={25} onClick={() => setPass('text')} />}
                                    </div>
                                </div>
                                <button type='submit' className='w-100 btn-primary rounded-5'>Proceed {loading && <Spinner size='sm' />}</button>
                            </Form>
                            <div className='px-3 text-end'><Link to='/auth/login' className='primary-text text-decoration-none'>Back to login</Link></div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
};

export default AdminResetPassword;
